import type { ImprovementAreaResponse } from 'api/__GENERATED';
import { apiUtility, domainUtility } from 'utility';

import { toImprovementArea } from './toImprovementArea';

// Builds a normalized `Data.ImprovementArea` domain from a list of DTOs.
function toImprovementAreaDomain(args: { dtos: ImprovementAreaResponse[] }) {
  const { dtos } = args;

  const improvementAreaDomain: NormalizedDomain<Data.ImprovementArea> = {
    allIds: [],
    byId: {},
  };

  apiUtility.iterator({
    list: dtos,
    transformer: (item) => {
      const improvementArea = toImprovementArea(item);
      domainUtility.mutateAdd(improvementAreaDomain, improvementArea);
    },
  });

  return { improvementAreaDomain };
}

export { toImprovementAreaDomain };
